module.exports = __webpack_public_path__ + "img/form.ec2ab1bc.svg";